import {
    Sliders,
    Clipboard,
    Edit3
} from "react-feather";

const pagesSection = [
    {
        href: "/overview",
        icon: Sliders,
        title: "Overzicht",

    },
    {
        href: "/preface",
        icon: Edit3,
        title: "Voorbrief",
    },
    {
        href: "/print",
        icon: Clipboard,
        title: "Print",

    },
];

const navItems = [
    {
        title: "",
        pages: pagesSection,
    },
];

export default navItems;
